"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fs_1 = __importDefault(require("fs"));
const error_1 = require("../../utils/error");
const utils_1 = require("./utils");
const typoOfDrawOptions = {
    chro_thickness: 'number',
    no_label: 'boolean',
    label_font_size: 'number',
    label_angle: 'number',
    label_pos: 'string',
    label_x_offset: 'number',
    label_y_offset: 'number',
    chro_axis: 'boolean',
    chro_axis_unit: 'string',
    chro_axis_pos: 'string',
    gap_length: 'number',
    align: 'string',
};
function paramsCreater() {
    const options = this;
    const drawOptions = [];
    const { parameter, parameterContent } = options;
    const defualtDrawOptionsItem = {
        chro_thickness: options.chro_thickness,
        no_label: options.no_label,
        label_font_size: options.label_font_size,
        label_angle: options.label_angle,
        label_pos: options.label_pos,
        label_x_offset: options.label_x_offset,
        label_y_offset: options.label_y_offset,
        chro_axis: options.chro_axis,
        chro_axis_pos: options.chro_axis_pos,
        chro_axis_unit: (0, utils_1.parseParamAxisUnit)(options.chro_axis_unit, 'chro_axis_unit'),
        gap_length: options.gap_length,
        align: options.align,
    };
    options.defualtDrawOptionsItem = defualtDrawOptionsItem;
    options.getDrawOptionsItem = (index) => index in drawOptions ? drawOptions[index] : defualtDrawOptionsItem;
    const content = parameter ? fs_1.default.readFileSync(parameter).toString().trim() : parameterContent === null || parameterContent === void 0 ? void 0 : parameterContent.trim();
    const parameterFile = parameter ? parameter : 'PARAMETER';
    if (!content)
        return options;
    const lines = content.split('\n');
    for (let index = 0, lineCount = lines.length; index < lineCount; index++) {
        const line = lines[index];
        if (line.trim() === '') {
            drawOptions.push(Object.assign({}, defualtDrawOptionsItem));
            continue;
        }
        ;
        const items = line.split(/\s+/);
        const drawOptionsItem = Object.assign({}, defualtDrawOptionsItem);
        for (let item of items) {
            const [drawOption, value] = item.split('=');
            let convertValue = value;
            if (!(drawOption in typoOfDrawOptions)) {
                const info = (0, error_1.errorPos)(line, drawOption, item);
                (0, error_1.warn)(`Illegal drawoption in '${drawOption}' ${parameter} line ${index + 1}\n${info}`);
                continue;
            }
            const typeOfDrawOption = typoOfDrawOptions[drawOption];
            try {
                if (typeOfDrawOption === 'boolean') {
                    convertValue = Boolean(value);
                    if (!value) {
                        convertValue = true;
                    }
                    else if (['false', 'f'].includes(value.toLowerCase())) {
                        convertValue = false;
                    }
                }
                else if (typeOfDrawOption === 'number') {
                    convertValue = (0, utils_1.parseParamFloat)(value, drawOption);
                }
                else if (typeOfDrawOption === 'string') {
                    if (drawOption === 'label_pos') {
                        convertValue = (0, utils_1.parseParamLabelPos)(value, drawOption);
                    }
                    else if (drawOption === 'align') {
                        convertValue = (0, utils_1.parseParamAlign)(value, drawOption);
                    }
                    else if (drawOption === 'chro_axis_unit') {
                        convertValue = (0, utils_1.parseParamAxisUnit)(value, drawOption);
                    }
                }
            }
            catch (error) {
                const errPosInfo = (0, error_1.errorPos)(line, value, item);
                error.message = `${error.message} at ${parameterFile} line ${index + 1}\n${errPosInfo}`;
                throw error;
            }
            drawOptionsItem[drawOption] = convertValue;
        }
        drawOptions.push(drawOptionsItem);
    }
    options.drawOptions = drawOptions;
    return options;
}
exports.default = paramsCreater;
__exportStar(require("./utils"), exports);
